module.exports = __webpack_public_path__ + "img/ai-7.2a1d5ee.png";